module.exports = __webpack_public_path__ + "static/media/たいやき.47777499.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/store/たいやき.png
// module id = 334
// module chunks = 10